module.exports = __webpack_public_path__ + "static/media/dummy-preview.269f2427.jpg";